import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { BulkEditSectionFormService, ZagSwitch } from '@zag/ui';

const SECTION_ID = 'bulk-status';

interface State {
  active: boolean;
}

@Component({
  selector: 'sc-user-status-bulk-section',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ZagSwitch, TranslatePipe],
  template: `
    <div class="sc-user-status-bulk-section">
      <span>{{ (state().active ? 'bulkEdit.users.status.active' : 'bulkEdit.users.status.inactive') | translate }}</span>
      <zag-switch
        [checked]="state().active"
        [ariaLabel]="'bulkEdit.users.status.ariaLabel' | translate"
        (checkedChange)="onActiveChange($event)"
      />
    </div>
  `,
  styles: [
    `
      .sc-user-status-bulk-section {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        gap: 0.75rem;
      }
    `,
  ],
})
export class UserStatusBulkSectionComponent implements OnInit, OnDestroy {
  private readonly formService = inject(BulkEditSectionFormService);

  protected readonly state = signal<State>({ active: true });

  protected onActiveChange(active: boolean): void {
    this.state.set({ active });
  }

  ngOnInit(): void {
    this.formService.register(SECTION_ID, () => this.state());
  }

  ngOnDestroy(): void {
    this.formService.unregister(SECTION_ID);
  }
}
